import { usersService } from '@/services/UsersService';
import { storeService } from '@/services/StoreService';

const state = () => ({
  invitated_users: [],
  users: [],
});

const mutations = {
  setUsers(state: any, users: any) {
    state.users = users;
  },
  setInvitations(state: any, invitations: any) {
    state.invitated_users = invitations;
  },
};

const actions = {
  getUsers({ commit, rootState }: any) {
    return usersService.getUsers(rootState.currentWorkspace.id).then(data => {
      commit('setUsers', data.users);
      commit('setInvitations', data.invitated_users);
      storeService.getCurrentWorkspaceRole();
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
